import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import Genre from '@/components/screens/genre/Genre';
import { BOOKS_FOR_PAGE, API_URL } from '@/helpers/variables';
import { IGenreBooksPage } from '@/interfaces/genreBooksPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';

interface IGenrePageDynamicProps extends IWidgetsSideBar {
  books: IGenreBooksPage;
  freeBooks: boolean;
}

const GenrePageDynamic: NextPage<IGenrePageDynamicProps> = ({ books, freeBooks, todayWidget, popularBooksWidget }) => {
  return <Genre books={books} freeBooks={freeBooks} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { alias, free_books, page } = context.query;

  const [booksRes] = await Promise.all([fetch(`${API_URL}genres/books/${alias}?${!!free_books ? `free_book=true&` : ``}page=${page ? page : `1`}&page_size=${BOOKS_FOR_PAGE}`)]);

  // Check for redirect genres
  if (booksRes.status === 404) {
    const errorResponse = await booksRes.json();
    const redirectUrl = errorResponse.detail?.url;

    if (redirectUrl) {
      return {
        redirect: {
          destination: redirectUrl,
          permanent: true,
        },
      };
    }
  }

  // Check fetch error
  if (!booksRes.ok) {
    console.table(`Error ${booksRes.status}. Api: ${booksRes.url}`);
    return {
      notFound: true,
    };
  }

  const [books] = await Promise.all([booksRes.json()]);
  const freeBooks = !!free_books;

  // Check Fetched Data Error
  if (!books.books) {
    return {
      notFound: true,
    };
  }

  const [todayWidgetRes, popularBooksWidgetRes] = await Promise.all([fetch(`${API_URL}main/today/`), fetch(`${API_URL}main-page/popular_books`)]);
  const [todayWidget, popularBooksWidget] = await Promise.all([todayWidgetRes.json(), popularBooksWidgetRes.json()]);

  return { props: { books, freeBooks, todayWidget, popularBooksWidget } };
};

export default GenrePageDynamic;
